import { useAppContextController } from "context/AppContext";
import CustomCard from "components/CustomCard";
import { customPanelCard } from "layouts/pages/customers/styles";
import { Download, Menu } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import { Box, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { formatResumeData } from "utils/resumeFormatter";
import { getCompanyBaseImageUrl } from "utils/helpers/upload";
import { fetchAndConvertToBase64 } from "utils/imageUtils";
import ResumeContent from "./ResumeContent";
import { ResumeDownloadButton } from "./components/ResumePDF";

const ApplicantResume = () => {
  const { currentApplicant, isMobile, company } = useAppContextController();
  const [companyLogoBase64, setCompanyLogoBase64] = useState("");
  const [logoLoading, setLogoLoading] = useState(false);

  const formattedResumeData = formatResumeData(currentApplicant);
  const logoSrc = getCompanyBaseImageUrl(company)
    ? `${getCompanyBaseImageUrl(company)}/square-logo/${company?.squareLogoUrl}`
    : "";

  useEffect(() => {
    if (logoSrc) {
      setLogoLoading(true);
      fetchAndConvertToBase64(logoSrc)
        .then((base64Data) => {
          setCompanyLogoBase64(base64Data);
          setLogoLoading(false);
        })
        .catch((error) => {
          console.error("Error loading or converting logo to base64:", error);
          setCompanyLogoBase64("");
          setLogoLoading(false);
        });
    } else {
      setCompanyLogoBase64("");
      setLogoLoading(false);
    }
  }, [logoSrc]);

  const isDownloadReady = !logoLoading && (companyLogoBase64 || !logoSrc);

  return (
    <CustomCard
      icon={<Menu color="white" />}
      cardTitle="Resume"
      cardActions={
        currentApplicant?.resumeData?.parsedResume && (
          <Tooltip title={logoLoading ? "Preparing logo..." : "Download Resume PDF"}>
            <span>
              <ResumeDownloadButton
                resumeData={formattedResumeData}
                buttonText={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Download fontSize="small" />
                    {!isMobile && (logoLoading ? "Preparing..." : "Download PDF")}
                  </Box>
                }
                companyName={company.name}
                companyLogo={companyLogoBase64}
                disabled={!isDownloadReady}
              />
            </span>
          </Tooltip>
        )
      }
      {...customPanelCard(isMobile, "primary")}
    >
      {currentApplicant?.resumeData?.parsedResume ? (
        <ResumeContent resumeData={formattedResumeData} />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          minHeight="250px"
        >
          <MDTypography>Resume data not available</MDTypography>
        </Box>
      )}
    </CustomCard>
  );
};

export default ApplicantResume;
